// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1R8fw","comment":"styles_comment__3JUJ_"};